export default "__VITE_ASSET__Podylxdb__";